<template>

  <div class="mycontainer">
    <div class="headerclass">{{titleDic[typeindex]}}列表</div>
    <button class="submitclass" @click="$router.go(-1)">返回</button>
    <!--<div class="keywordclass">-->
      <!--<span>关键字：</span>-->
      <!--<div style="width: 280px">-->
        <!--<el-input v-model="keyword" maxlength="20" placeholder="请输入角色名称"></el-input>-->
      <!--</div>-->
      <!--<button class="submitclass" @click="getInformationDetail">搜索</button>-->
    <!--</div>-->
    <div class="tableclass">
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          header-align="center"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          label="内容摘要"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div @click="getDetailInfor(scope.row.id)" type="text" size="small" class="textline1 detailinfor">{{scope.row.title?scope.row.title:scope.row.enterName}}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="typeindex==6||typeindex==5"
          prop="content"
          label="内容"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="typeindex!=6&&typeindex!=5"
          prop="type"
          label="分类"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="typeindex==6||typeindex==5"
          label="部门"
          prop="depart"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="typeindex!=6&&typeindex!=5"
          label="信息来源"
          prop="urlName"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          label="发布日期"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="textline1 detailinfor">{{scope.row.pubdate?scope.row.pubdate:scope.row.pubDate}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageclass" v-if="totalcount>0">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          layout="total,prev, pager, next,jumper"
          :total="totalcount"
          :page-size="endPage"
          @size-change="handleSizeChange"
          :current-page.sync="startPage"
        >
        </el-pagination>
      </div>

    </div>

  </div>

</template>

<script>
  import * as api from "../../utils/api"
  import axios from "axios";

  export default {
    components: {

    },
    name: "information-list",
    data(){
      return{
        keyword:'',
        userName:'',
        tempId:'tem_01',
        startPage:Number(this.$route.params.startPage),//当前页数
        endPage: 10,//当前页面个数
        totalcount: 0,//总个数
        tableData: [],
        loading:false,
        type:{0:'国内科创动态,国外科创动态',1:'推荐项目',2:'通知公告',3:'国内科创动态',4:'国外科创动态'},
        typeindex:Number(this.$route.query.typeindex),
        titleDic:{
          0:'科创（国合）头条',
          1:'驻外科技机构推荐项目',
          2:'通知公告',
          3:'国内科技动态',
          4:'海外科技动态',
          5:'今日提醒',
          6:'今日预警'
        }
      }
    },
    watch:{
      $route(){
        this.startPage=Number(this.$route.params.startPage);
        this.getInformationDetail();
      },
      startPage(val){
        if(val == 1){
          let {name,params,query}=this.$route;
          this.$router.push({
            name,params:{
              startPage:1,
            },query:{
              typeindex:this.$route.query.typeindex
            }
          })
        }
      }
    },
    mounted(){


      if(this.typeindex==6){
        this.getWarningList();
      }else if(this.typeindex==5){

        this.getRemindList();
      }else{
        this.getInformationDetail();

      }
    },
    methods:{
      getInformationDetail() {

        this.loading=true;
        var self = this;
        api.getInformationDetail({
          type:this.type[this.typeindex],
          startPage: this.startPage,
          endPage: this.endPage
        })
          .then(rs => {
            self.loading=false;

            console.log(rs)
            if (rs.status == 200) {
              self.tableData=rs.data.list;
              self.totalcount=Number(rs.data.count);

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },
      //预警
      getWarningList() {

        this.loading=true;
        var self = this;
        api.getWarningList({
          startPage: this.startPage,
          endPage: this.endPage
        })
          .then(rs => {
            self.loading=false;

            console.log(rs)
            if (rs.status == 200) {
              self.tableData=rs.data.list;
              self.totalcount=Number(rs.data.count);

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },
      //今日提醒
      getRemindList() {

        this.loading=true;
        var self = this;
        api.getRemindList({
          startPage: this.startPage,
          endPage: this.endPage
        })
          .then(rs => {
            self.loading=false;

            console.log(rs)
            if (rs.status == 200) {
              self.tableData=rs.data.list;
              self.totalcount=Number(rs.data.count);

            } else {
              self.$message.error(rs.message)

            }

          })
          .catch(err => {
            self.$message.error(err)
            self.loading=false;

          })
      },

      handleCurrentChange: function (val) {
        console.log('=======',this.typeindex)

        this.startPage = Number(`${val}`);
        if(this.typeindex==6){
          this.getWarningList();
        }else if(this.typeindex==5){

          this.getRemindList();
        }else{
          this.getInformationDetail();

        }
        },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.endPage = Number(`${val}`);
        if(this.typeindex==6){
          this.getWarningList();
        }else if(this.typeindex==5){

          this.getRemindList();
        }else{
          this.getInformationDetail();

        }
      },
      //获取详情信息
      getDetailInfor(id){
        // console.log(id,this.typeindex)

        this.$router.push({
          name: 'informationdetail',
          query:{
            id:id,
            typeindex:this.typeindex
          }
        })
      },
    }
  }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>
  .mycontainer{
    .detailinfor{
      cursor: pointer;
    }
    .detailinfor:hover{
      color: #0a7afc;
    }
    background: #fff;
    width: 100%;
    min-height: calc(100vh - 70px);
    position: relative;
    .headerclass{
      padding: 20px 0;
      margin: 0 20px;
      height: 15px;
      font-size: 16px;
      color: #2a3138;
      border-bottom: 1px solid #e6eaf0;
    }
    .submitclass{
      position: absolute;
      right: 0px;
      top: 10px;
    }
    .addrole{
      position: absolute;
      right: 0;
      top: 10px;
    }
    .tableclass{
      padding: 20px;
    }
    .keywordclass{
      display: flex;
      flex-wrap: wrap;
      padding: 0 20px;
      line-height: 40px;
      margin-top: 20px;
      span{
        color: #2a3138;
        font-size: 14px;
      }
      button{
        margin-left: 20px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/informationList.vue